module.exports = __webpack_public_path__ + "static/media/glogo.18b3764e.png";